import React, {Component} from 'react'

import CRUDManagerGenerator from '../generators/CRUDGenerator'
import {checkPermission, CAN_CREATE_PROJECT_STATUSES, CAN_EDIT_PROJECT_STATUSES} from "../../../lib/permissions";

const create = {
    table: 'project_statuses',
    mutationType: 'upsert_',
    schema: {
        title: 'Create Project Status',
        type: 'object',
        required: ['description', 'hexcode', 'display_timesheet_warning'],
        properties: {
            description: {type: 'string', title: 'Description'},
            hexcode: {type: 'string', title: 'Colour', default: '#000000'},
            display_timesheet_warning: {
                title: 'Can Add to Timesheet',
                type: "number",
                enum: [0, 1],
                enumNames: ["True", "False"]
            }
        }
    },
    uiSchema: {
        hexcode: {
            "ui:widget": "color"
        },
        //display_timesheet_warning: {"ui:widget": "checkbox"}
    },
    formData: {
        display_timesheet_warning: 0
    }
    //widgets
}

const update = {
    table: 'project_statuses',
    mutationType: 'upsert_',
    schema: {
        title: 'Update Project Status',
        type: 'object',
        required: ['description', 'hexcode', 'display_timesheet_warning'],
        properties: {
            project_status_id: {type: 'integer'},
            description: {type: 'string', title: 'Description'},
            hexcode: {type: 'string', title: 'Colour'},
            display_timesheet_warning: {
                title: 'Can Add to Timesheet',
                type: "number",
                enum: [0, 1],
                enumNames: ["True", "False"]
            }
        }
    },
    uiSchema: {
        project_status_id: {"ui:widget": "hidden"},
        hexcode: {
            "ui:widget": "color",
            style: {'height': '50px'}
        },
        //display_timesheet_warning: {"ui:widget": "checkbox"}
    },
    //widgets
}

const read = {
    title: 'Project Statuses',
    description: 'Project Statuses define the state a project is in.',
    table: 'project_statuses',
    fields: ['project_status_id', 'description', 'hexcode', 'display_timesheet_warning'],
    uniqueKey: 'project_status_id',
    columns: [
        {Header: 'ID', accessor: 'project_status_id', maxWidth: '100'},
        {Header: 'Desc', accessor: 'description'},
        {Header: 'Colour', accessor: 'hexcode', type: 'colour', maxWidth: '100'},
        {
            Header: 'Can Add to Timesheet',
            accessor: 'display_timesheet_warning',
            maxWidth: '100',
            Cell: row => (
                <p className={'text-center' && (row.value) ? 'text-dark' : 'text-primary'}>{(row.value) ? 'False' : 'True'}</p>
            )
        }
    ]
}

const config = {
    create,
    read,
    update
}


const CRUDManager = CRUDManagerGenerator(config)

class ProjectStatuses extends Component{

    render(){
        return (
            <CRUDManager
                canCreate={checkPermission(CAN_CREATE_PROJECT_STATUSES)}
                canEdit={checkPermission(CAN_EDIT_PROJECT_STATUSES)}
            />
        )
    }
}

export default ProjectStatuses